import { Chip } from '@material-ui/core';
import React from 'react';
import { STATUS_TYPES_LABEL } from '../../../state/ducks/dashboard.new/my.feeds/types';
import { FormHeaderStatusClassMapping } from '../common/header/Helpers';
import useStyles from './whereUsedTree.styles';

const WHERE_USED_STATUS_ALIAS: Record<string, string> = {
  DEPRECATED: 'SUPERSEDED',
};

export default function StatusChip ({ status }: { status: string }): JSX.Element {
  const classes = useStyles({ size: undefined });
  const upperStatus = status?.toUpperCase();
  const resolvedStatus: string = WHERE_USED_STATUS_ALIAS[upperStatus] ?? upperStatus;

  return (
    <Chip
      size="small"
      className={`${classes.chip} ${
        classes[FormHeaderStatusClassMapping[resolvedStatus || ''] as string] as string
      }`}
      label={STATUS_TYPES_LABEL[resolvedStatus] as string}
      data-cy="where-used-status"
    />
  );
}
